import { render, staticRenderFns } from "./SidenavHeader.vue?vue&type=template&id=142c5fd1&"
import script from "./SidenavHeader.vue?vue&type=script&lang=js&"
export * from "./SidenavHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports